var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSportsExotics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "50px",
    viewBox: "0 0 28 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ICON_Sports_Exotics",
    transform: "translate(-11.000000, 0.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(10.999979, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.000021,47.3355754 C7.71780098,47.3355754 2.62502098,42.1663075 2.62502098,35.7897355 C2.62502098,29.4131634 7.71780098,24.2438955 14.000021,24.2438955 C20.282311,24.2438955 25.375021,29.4131634 25.375021,35.7897355 C25.375021,42.1663075 20.282311,47.3355754 14.000021,47.3355754 L14.000021,47.3355754 Z M9.62502098,18.8688629 C9.62502098,18.8195533 9.66758098,18.7762831 9.71623098,18.7762831 L18.283811,18.7762831 C18.332461,18.7762831 18.375021,18.8195533 18.375021,18.8688629 L18.375021,22.2881368 C16.998401,21.828861 15.528051,21.5794709 14.000021,21.5794709 C12.471991,21.5794709 11.001571,21.828861 9.62502098,22.2881368 L9.62502098,18.8688629 Z M20.125021,23.0087393 L20.125021,18.8688629 C20.125021,17.8384056 19.299021,17 18.283811,17 L17.936261,17 L9.85336098,17 L9.71623098,17 C8.70102098,17 7.87502098,17.8384056 7.87502098,18.8688629 L7.87502098,23.0087393 C3.21274098,25.3149231 2.0983449e-05,30.1712811 2.0983449e-05,35.7897355 C2.0983449e-05,43.6378514 6.26803098,50 14.000021,50 C21.732011,50 28.000021,43.6378514 28.000021,35.7897355 C28.000021,30.1712811 24.787231,25.3149231 20.125021,23.0087393 L20.125021,23.0087393 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.000021,27 C9.02950098,27 5.00002098,31.029408 5.00002098,36 C5.00002098,40.970592 9.02950098,45 14.000021,45 C18.970613,45 23.000021,40.970592 23.000021,36 C23.000021,31.029408 18.970613,27 14.000021,27",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    d: "M28.000021 0 19.8996616 0 15.000021 8.75929638 19.0502007 16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    d: "M9.79598327 16 11.7397501 16 17.000021 16 8.07652952 0 0 0 8.92349146 16z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportsExotics);
export default ForwardRef;